import styled from 'styled-components'
import React from 'react';

const Container = styled.div`
    /* width: 500px; */
    /* height: 500px; */
    width: 49%;
    border: 1px solid #ddd;
    padding: 20px;
`;

const Title = styled.div`
    font-family: AvenirNext-DemiBold;
    font-size: 20px;
    margin-bottom: 10px;
`;

const Subtitle = styled.div`
  font-family: AvenirNext-Regular;
  font-size: 20px;
  margin-bottom: 10px;
`;

const Widget = props => (
  <Container>
    <Title>{props.title}</Title>
    {
      props.subtitle &&
      <Subtitle>{props.subtitle}</Subtitle>
    }
    {props.children}
  </Container>
);

export default Widget;